import { ArmyBook } from '@Models';
import {
  buildEntityActionState,
  EntityActionState,
} from '@Stores/EntityActionState';

export type ArmyBookState = EntityActionState<ArmyBook>;

export const buildArmyBookState = (data: Partial<ArmyBookState> = {}) =>
  buildEntityActionState<ArmyBook>(data);

export enum ArmyBookActionState {
  Make = 0,
  Print = 1,
}
